import { CustomFont, CustomTheme } from "@easyteam/core-ui";
import { theme } from "styles/theme";

import { UserRole } from "types/BETypes";

import { easyTeamColors } from "./colors";

export const easyTeamFonts: CustomFont = {
  regular: theme.fontFamily.default,
  bold: theme.fontFamily.default,
  semiBold: theme.fontFamily.default,
};

const eastTeamThemeBase: CustomTheme = {
  tokens: easyTeamColors,
  button: {
    default: {
      fontSize: theme.size.body2,
    },
    primary: {
      fontSize: theme.size.body2,
      backgroundColor: "primary.main",
      color: "primary.accent.main",
      _hover: {
        backgroundColor: "primary.dark",
        color: "primary.accent.dark",
      },
      _active: {
        backgroundColor: "primary.darker",
        color: "primary.accent.darker",
      },
      _focus: {
        backgroundColor: "primary.dark",
        color: "primary.accent.dark",
      },
    },
    secondary: {
      fontSize: theme.size.body2,
      backgroundColor: "secondary.main",
      color: "secondary.accent.main",
      _hover: {
        backgroundColor: "secondary.dark",
        color: "secondary.accent.dark",
      },
      _active: {
        backgroundColor: "secondary.darker",
        color: "secondary.accent.darker",
      },
      _focus: {
        backgroundColor: "secondary.dark",
        color: "secondary.accent.dark",
      },
    },
    destructive: {
      fontSize: theme.size.body2,
      _hover: {
        backgroundColor: "delete.hover",
        color: "delete.hoverAccent",
      },
      _active: {
        backgroundColor: "delete.active",
        color: "delete.activeAccent",
      },
    },
  },
  dateSelector: {
    dateSelectorPill: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "border.main",
    },
    dateSelectorPillIcon: {
      width: "16px",
      height: "16px",
    },
    dateSelectorPillText: {
      fontSize: theme.size.body2,
      fontWeight: theme.fontWeight.regular,
    },
  },
  employeeSelector: {
    employeeSelectorPill: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "border.main",
    },
    employeeSelectorAvatar: {
      width: "24px",
      height: "24px",
      borderRadius: "50%",
    },
    employeeSelectorName: {
      fontSize: theme.size.body2,
      fontWeight: theme.fontWeight.regular,
    },
  },
  table: {
    tableContainer: {
      borderStyle: "solid",
      borderWidth: "1px",
      borderRadius: "8px",
      borderColor: "border.main",
    },
    tableHeaderValue: {
      fontWeight: theme.fontWeight.semiBold,
    },
    tableHeaderCell: {
      borderWidth: "0 0 1px 0",
      borderColor: "border.main",
      borderStyle: "solid",
      borderRadius: 0,
      padding: "12px 16px",
      height: "40px",
    },
    tableRow: {
      borderWidth: "0 0 1px 0",
      borderColor: "border.main",
      borderStyle: "solid",
      borderRadius: 0,
      padding: "4px 16px",
      height: "48px",
    },
    tableRowValue: {
      fontSize: theme.size.body2,
      fontWeight: theme.fontWeight.regular,
    },
  },
  employeesList: {
    titleMain: {
      fontSize: theme.size.titleSemiLargeAlt,
      fontWeight: theme.fontWeight.semiBold,
    },
    employeeListAvatar: {
      borderRadius: "50%",
      width: "32px",
      height: "32px",
    },
    employeeListOpenChevron: {
      fontSize: "20px",
      color: theme.colors.textAlt4,
    },
    employeeListTotals: {
      height: "36px",
      fontWeight: theme.fontWeight.bold,
    },
  },
  timesheet: {
    timesheetsCTASecondary: {
      backgroundColor: "secondary.main",
      color: "secondary.accent.main",
      _hover: {
        backgroundColor: "secondary.dark",
        color: "secondary.accent.dark",
      },
      _active: {
        backgroundColor: "secondary.darker",
        color: "secondary.accent.darker",
      },
      _focus: {
        backgroundColor: "secondary.dark",
        color: "secondary.accent.dark",
      },
    },
    timesheetsActionMenuWrapper: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "border.main",
      borderRadius: "8px",
    },
    timesheetTotals: {
      height: "36px",
      fontWeight: theme.fontWeight.bold,
      borderBottomWidth: 0,
    },
  },
  screen: {
    title: {
      fontSize: theme.size.titleSemiLargeAlt,
      fontWeight: theme.fontWeight.semiBold,
    },
  },
  shiftForm: {
    shiftSingle: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "border.main",
    },
    dateSelectorWrapper: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "border.main",
      borderRadius: "8px",
    },
    selectorWrapper: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "border.main",
      borderRadius: "8px",
    },
    shiftSummaryBox: {
      backgroundColor: theme.colors.colorsNew.gray["200"],
      border: "1px solid",
      borderColor: theme.colors.colorsNew.gray["300"],
    },
    shiftSummaryBoxTitle: {
      fontSize: theme.size.body1,
      fontWeight: theme.fontWeight.semiBold,
      color: theme.colors.colorsNew.gray["900"],
    },
    shiftSummaryColumnTitle: {
      fontSize: theme.size.caption,
      fontWeight: theme.fontWeight.regular,
      color: theme.colors.colorsNew.gray["600"],
    },
    shiftSummaryColumnValue: {
      fontSize: theme.size.body2,
      fontWeight: theme.fontWeight.regular,
      color: theme.colors.colorsNew.gray["900"],
    },
    shiftDeleteButton: {
      backgroundColor: "delete.main",
      color: "delete.accent",
      _hover: {
        backgroundColor: "delete.hover",
        color: "delete.hoverAccent",
      },
      _active: {
        backgroundColor: "delete.active",
        color: "delete.activeAccent",
      },
    },
  },
  settings: {
    teamAvatar: {
      borderRadius: "50%",
    },
    breakWrapper: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "border.main",
      borderRadius: "8px",
    },
    breakSelectorWrapper: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "border.main",
      borderRadius: "8px",
    },
    breakSelectorTitle: {
      fontSize: theme.size.body1,
      fontWeight: theme.fontWeight.semiBold,
    },
    breakSelectorValue: {
      fontSize: theme.size.body2,
    },
    teamName: {
      fontSize: theme.size.body2,
    },
  },
};

export const easyTeamTheme = (role: UserRole): CustomTheme => {
  if ([UserRole.ADMIN, UserRole.SUPERADMIN, UserRole.OWNER].includes(role as UserRole)) {
    return {
      ...eastTeamThemeBase,
      timesheet: {
        ...eastTeamThemeBase.timesheet,
        timesheetsCTASecondary: {
          fontSize: theme.size.body2,
          backgroundColor: theme.colors.secondaryButtonBg,
          border: `1px solid ${theme.colors.secondaryButtonText}`,
          color: theme.colors.secondaryButtonText,
          _hover: {
            backgroundColor: theme.colors.secondaryButtonBgAlt,
            color: theme.colors.secondaryButtonTextAlt,
            borderColor: theme.colors.secondaryButtonTextAlt,
          },
          _active: {
            backgroundColor: theme.colors.secondaryButtonBgAlt,
            color: theme.colors.secondaryButtonTextAlt,
            borderColor: theme.colors.secondaryButtonTextAlt,
          },
          _focus: {
            backgroundColor: theme.colors.secondaryButtonBgAlt,
            color: theme.colors.secondaryButtonTextAlt,
            borderColor: theme.colors.secondaryButtonTextAlt,
          },
        },
      },
    };
  }

  return {
    ...eastTeamThemeBase,
    timesheet: {
      ...eastTeamThemeBase.timesheet,
      timesheetsCTASecondary: {
        ...eastTeamThemeBase.button?.primary,
      },
    },
  };
};
